<template>
  <div class="container">
    <h1 class="title is-3">Thank you for your purchase</h1>
    <p>Your order is on the way</p>
  </div>
</template>
<script>
export default {
  mounted() {
    gtag("event", "conversion", {
      send_to: "AW-974458431/-ZaLCMiClOgCEL-c1NAD",
      value: 1,
    })
  },
}
</script>
<style lang="scss" scoped>
.container {
  text-align: center !important;
}
</style>